<template>
  <v-tooltip v-if="kpi.tooltip" :open-delay="200" bottom>
    <template #activator="{ on, attrs }">
      <v-card
        class="metric-card"
        :class="{ highlight: kpi.highlight }"
        outlined
        v-bind="attrs"
        v-on="on"
      >
        <div
          class="metric-number"
          :class="{
            'metric-number--long': kpi.value?.toString().length > 12,
          }"
        >
          {{ kpi.value }}
        </div>
        <div class="metric-label">{{ kpi.label }}</div>
      </v-card>
    </template>

    <span>{{ kpi.tooltip }}</span>
  </v-tooltip>

  <v-card v-else class="metric-card" :class="{ highlight: kpi.highlight }" outlined>
    <div
      class="metric-number"
      :class="{
        'metric-number--long': kpi.value?.toString().length > 12,
      }"
    >
      {{ kpi.value }}
    </div>
    <div class="metric-label">{{ kpi.label }}</div>
  </v-card>
</template>

<script>
export default {
  name: 'KpiCard',

  props: {
    kpi: {
      type: Object,
      required: true,
      validator: value => ['label', 'value'].every(prop => prop in value), // label, value, tooltip (optional)
    },
  },
};
</script>

<style lang="scss" scoped>
.metric-card {
  background: var(--color-off-white);
  padding: 2rem 1.5rem;
  text-align: center;
  box-shadow: 0 0.125rem 0.75rem rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-0.2rem);
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.12);
  }

  .metric-number,
  .metric-label {
    color: var(--color-off-white);
  }

  .metric-number {
    font-size: 2.5rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 8px;
    color: var(--v-primary-base);
    white-space: nowrap;

    &--long {
      font-size: 1.5rem;
    }
  }

  .metric-label {
    font-size: 0.875rem;
    color: #616161;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  &.highlight {
    background: linear-gradient(
      135deg,
      var(--v-primary-lighten1) 0%,
      var(--v-primary-darken1) 100%
    );
    color: var(--color-off-white);
  }
}

:deep(.v-tooltip__content) {
  background: rgba(33, 33, 33, 0.97);
  color: white;
  font-size: 12px;
  padding: 8px 12px;
  border-radius: 4px;
  max-width: 250px;
  text-align: left;
}

@media (max-width: 768px) {
  .metric-number {
    font-size: 2rem;

    &--long {
      font-size: 1.2rem;
    }
  }
}
</style>
